
const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?\\/~`-])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?\\/~`-]{8,}$/;
export function validateEmail(email: string): boolean {
  return emailRegex.test(email);
}

export function validatePassword(password: string): boolean {
  return passwordRegex.test(password);
}

export const isStringEmpty = (str: string): boolean => {
  const regex = /\S/;
  return !regex.test(str);
}


